import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import AvailableOnOs from "@insightfulscience/atomic-react/AvailableOnOs";
import AvailableOnOsIconContainer from "@insightfulscience/atomic-react/AvailableOnOs/Icon";
import AvailableOnOsBody from "@insightfulscience/atomic-react/AvailableOnOs/Body";

const SectionTryForFree = () => {
	const [t] = useLocale("available-on-os");
	return (
		<AvailableOnOs>
			<AvailableOnOsIconContainer>
				<AvailableOnOsIconContainer.Icon name="mac" />
				<AvailableOnOsIconContainer.Icon name="windows" />
			</AvailableOnOsIconContainer>
			<AvailableOnOsBody>
				<AvailableOnOsBody.Item>{t("PRISM_IS")}</AvailableOnOsBody.Item>
			</AvailableOnOsBody>
		</AvailableOnOs>
	);
};

export default SectionTryForFree;
